<template>
  <div class="subScription">
    <div class="menu">
      <el-menu
        default-active="1"
        class="el-menu-vertical-demo"
        background-color="#f6f8f9"
        router>
        <el-menu-item index="/configuration/subScription/home">
          <i class="el-icon-house"></i>
          <span slot="title">首页</span>
        </el-menu-item>
        <el-menu-item index="/configuration/subScription/config" v-if="showSet">
          <i class="el-icon-document"></i>
          <span slot="title">配置信息</span>
        </el-menu-item>
        <el-menu-item index="/configuration/subScription/menu" v-if="showSet">
          <i class="el-icon-setting"></i>
          <span slot="title">自定义菜单</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="content">
      <div class="cont">
        <transition name="el-fade-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  computed: {
    ...mapGetters(["crumbsCont", "token"])
  },
  data() {
    return {
      show: true,
      isCollapse: false,
      showSet: true, // 显示配置信息和自定义菜单
    };
  },
  methods: {
    ...mapMutations(["SET_TOKEN", "SET_APPID"]),
    change() {
      this.isCollapse = !this.isCollapse;
    },
    init(){
      var appId = localStorage.getItem('app_id')
      var yhApp = ['444','439','440','437'];
      if(yhApp.some(x => x == appId)){
        this.showSet = false;
      }
    }
  },
  mounted(){
    this.init()
  }
};
</script>

<style lang="scss" scoped>
.subScription{
  min-width: 1120px;
  height: 100%;
  overflow: auto;
  display: flex;
  .menu{
    padding-top:20px;
    border-right: 1px solid #eee;
    .el-menu{
      border:none;
    }
  }
  .content{
    flex:1;
  }
}
</style>
